import { render, staticRenderFns } from "./editname.vue?vue&type=template&id=6ab77526&"
import script from "./editname.vue?vue&type=script&lang=js&"
export * from "./editname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports